/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import chart from 'shared/ui/components/charts/chart';

const __vue_script__ = {
    name: 'LineChart',

    mixins: [chart],

    data() {
        return {
            legend: null,
            processing: false,
            activeLines: null
        };
    },

    methods: {
        initChart() {
            requestAnimationFrame(() => {
                if (!this.$refs['wrapper']) {
                    return;
                }
                this.processing = true;
                this.$refs['chart'].textContent = '';

                let chart;
                const { width, height } = this.$refs['wrapper'].getBoundingClientRect();
                const options = {
                    x: this.xMapper,
                    y: this.yMapper,
                    width,
                    height,
                    color: this.lineColor,
                    withTooltips: this.tooltips,
                    markerLine: this.markerLine,
                    verticalMarkers: this.verticalMarkers,
                    icons: this.icons,
                    title: ({ date }, index, data) => {
                        const d = this.$utils.time.dateToFormat(date, 'll');
                        let title = d;

                        for (const metric of this.activeLines) {
                            const m = this.$t(`analytics.metrics.${metric}.title`);
                            const c = data.filter(d => d.metric === metric).find(d => d.date === date);
                            if (c) {
                                title += `\n${m}: |${c.count}`;
                            }
                        }

                        return title;
                    }
                };

                if (this.zMapper) {
                    options.z = this.zMapper;
                    if (typeof this.lineColor === 'function') {
                        this.legend = new Set(this.data.map(this.zMapper));
                        this.activeLines = Array.from(this.legend);
                    }
                    chart = this.$utils.charts.MultilineChart(this.data, options);
                } else {
                    chart = this.$utils.charts.LineChart(this.data, options);
                }

                this.$refs['chart'].append(chart);
                this.processing = false;
            });
        },

        toggleLine(item) {
            const chart = this.$refs['chart'];
            const lines = chart.querySelectorAll(`.lines .${item}`);
            const circles = chart.querySelectorAll(`.point-tooltip .${item}`);

            if (this.activeLines.includes(item)) {
                lines.forEach(l => l.setAttribute('opacity', 0));
                circles.forEach(c => c.setAttribute('opacity', 0));
                this.activeLines = this.activeLines.filter(l => l !== item);
            } else {
                lines.forEach(l => l.setAttribute('opacity', 1));
                circles.forEach(c => c.setAttribute('opacity', 1));
                this.activeLines.push(item);
            }
        },

        humanizeAndCapitalize(item) {
            return this.$utils.strings.humanize(item, true);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-chart chart-widget"},[(_vm.legend)?_c('div',{staticClass:"legend"},_vm._l((_vm.legend),function(item){return _c('div',{staticClass:"pill",class:{ active: _vm.activeLines.includes(item) },on:{"click":function($event){return _vm.toggleLine(item)}}},[(_vm.lineColor(item))?_c('span',{staticClass:"color",style:({ 'background-color': _vm.lineColor(item) })}):_vm._e(),(_vm.icons[item])?_c('span',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.icons[item],"alt":item}})]):_vm._e(),_vm._v(_vm._s(_vm.$t(("analytics.metrics." + item + ".title"))))])}),0):_vm._e(),_c('div',{staticClass:"title"},[(_vm.icon)?_c('i',{class:("ic-" + _vm.icon)}):_vm._e(),_vm._v(_vm._s(_vm.$t(("analytics.charts." + _vm.name + ".title")))),_c('small',[_c('a',{staticClass:"has-action",class:{ active: _vm.currentTimespan === 'all'},on:{"click":function($event){return _vm.setTimespan('all')}}},[_vm._v(_vm._s(_vm.$t('analytics.charts.timespans.all')))]),_c('a',{staticClass:"has-action",class:{ active: _vm.currentTimespan === 'week'},on:{"click":function($event){return _vm.setTimespan('week')}}},[_vm._v(_vm._s(_vm.$t('analytics.charts.timespans.last_week')))])])]),_c('div',{ref:"wrapper",staticClass:"chart-wrapper"},[_c('loader',{attrs:{"status":_vm.loading || _vm.processing}},[_c('div',{ref:"chart",staticClass:"chart"})])],1),_c('div',{staticClass:"details"},[_vm._t("details")],2)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LineChart.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__